module.exports = __webpack_public_path__ + "res/ic_menu_campaigns.9381bcf2f3eab962559169a376024612.png";